import React from 'react'

function SInputImage({ imagePreview, onImageChange, onCancel , onRemove, inputName}) {
  return (
    <>
    <div className="image-input image-input-empty image-input-outline image-input-placeholder mb-3">
        <div className="image-input-wrapper w-150px h-150px"
        style={{
            backgroundImage: `url(${imagePreview || ''})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
        }}
        ></div>
        <label
            className="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow"
            data-kt-image-input-action="change"
            data-bs-toggle="tooltip"
            aria-label="Change avatar"
            data-bs-original-title="Change avatar"
            data-kt-initialized="1"
        >
            <i className="ki-outline ki-pencil fs-7"></i>
            <input type="file" name={inputName} accept=".png, .jpg, .jpeg" onChange={onImageChange} />
            <input type="hidden" name={`${inputName}_remove`} />
        </label>
        <span
            className={`btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow ${imagePreview ? 'd-flex' : 'd-none'} `}
            data-kt-image-input-action="cancel"
            data-bs-toggle="tooltip"
            aria-label="Cancel avatar"
            data-bs-original-title="Cancel avatar"
            onClick={onCancel} 
        >
            <i className="ki-outline ki-cross fs-2"></i>
        </span>
        <span
            className={`btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow ${imagePreview ? 'd-flex' : 'd-none'}`}
            data-kt-image-input-action="remove"
            data-bs-toggle="tooltip"
            aria-label="Remove avatar"
            data-bs-original-title="Remove avatar"
            data-kt-initialized="1"
            onClick={onRemove} 
        >
            <i className="ki-outline ki-cross fs-2"></i>
        </span>
    </div>
    </>
  )
}

export default SInputImage